import { Component, OnInit } from '@angular/core';
import { PersonService } from '../person.service';
import { ContactService } from '../contact.service';
import { ProjectService } from '../project.service';

import { Router } from '@angular/router';
@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.css']
})
export class ContactComponent implements OnInit {
  person;
  lastestProjects;
  project1;
  project2;
  message={
  name:'',
  email:'',
  message:'',
  subject:''
  };
  messageSent:boolean=false;
  errorMessage:string='';
  constructor(private router:Router,private personService:PersonService,private contactService:ContactService,private projectService:ProjectService) { }
  sendMessage()
  {
    if(this.message.name=='' || this.message.email=='' || this.message.message=='' || this.message.message=='' || this.message.subject=='')
    {
      this.errorMessage='Please fill the form first to submit';
      return;
    }
    this.contactService.sendMessage(this.message).subscribe(output=>{
      //console.log(output);
      this.messageSent=true;
    });
    this.errorMessage='';
    this.reloadComponent();
  }
  reloadComponent() {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigate(['/home']);
    console.log('what');
}
  ngOnInit() {
  this.person=this.personService.getPerson();
  this.lastestProjects=this.projectService.getLatestProjects();
  this.project1=this.lastestProjects[0];
  this.project2=this.lastestProjects[1];
  }

}
